import { render, staticRenderFns } from "./my_product.vue?vue&type=template&id=96996a2a"
import script from "./my_product.vue?vue&type=script&lang=js"
export * from "./my_product.vue?vue&type=script&lang=js"
import style0 from "./my_product.vue?vue&type=style&index=0&id=96996a2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports